import { Component, DestroyRef, Input, inject, ChangeDetectionStrategy } from '@angular/core';
import { GbrChildInput, GbrPersonType } from '@coin/shared/gbr/util';
import moment from 'moment';
import { GbrRequestDialogComponent } from '../../gbr-request-dialog.component';
import { SimpleGbrInputType, SimpleGbrInputComponent } from '../../inputs/simple-gbr-input/simple-gbr-input.component';
import { FormsModule } from '@angular/forms';
import { PersonViewComponent } from '../person-view/person-view.component';
import { TranslatePipe } from '@ngx-translate/core';
import { V2CardComponent } from '@coin/shared/core/ui-storybook';

@Component({
  selector: 'coin-siemens-energy-input-overview',
  templateUrl: './input-overview.component.html',
  styleUrls: ['./input-overview.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [SimpleGbrInputComponent, FormsModule, V2CardComponent, PersonViewComponent, TranslatePipe]
})
export class InputOverviewComponent {
  private readonly destroyRef = inject(DestroyRef);

  @Input() values: GbrRequestDialogComponent['travelPersons'];
  @Input() stepIndex = 0;

  public simpleInputTypes = SimpleGbrInputType;
  public personTypes = GbrPersonType;

  private isMinor(child?: GbrChildInput): boolean {
    return child && moment.utc().diff(child?.birthday, 'years') < 18;
  }

  private isAdult(child?: GbrChildInput): boolean {
    return child && moment.utc().diff(child?.birthday, 'years') >= 18;
  }

  get minorChildren(): GbrChildInput[] {
    return this.values.controls.children.value.filter(this.isMinor);
  }

  get adultChildren(): GbrChildInput[] {
    return this.values.controls.children.value.filter(this.isAdult);
  }
}
